import React from 'react';

import '@assets/charm.css';

import { CardsRoutesProvider } from '@apps/card/Card.routes';
import { ShopRouteCardCategoryProvider } from '@apps/card/components/CardCategoryProvider/ShopRouteCardCategoryProvider';
import { Redirect, Route, RoutesProvider, Switch } from '@shared/core';
import { Gallery } from './routes/Gallery';
import { PublicShopLoginProvider } from '@apps/card/routes/PublicShop/PublicShopLoginProvider';
import { PublicEnvelopes } from './routes/Envelopes';
import { FullScreenLogin } from './components/login/FullScreenLogin';
import { PublicCardShopTelemetryProvider } from './PublicShop.telemetry';

/**
 * TODO:
 * - Consolidate required providers into one wrapper component
 */
export const PublicShop = () => {
  return (
    <>
      <PublicCardShopTelemetryProvider>
        <PublicShopLoginProvider>
          <RoutesProvider>
            <CardsRoutesProvider>
              <ShopRouteCardCategoryProvider>
                <Switch>
                  <Route
                    path="/cards/envelopes"
                    render={() => <PublicEnvelopes />}
                  />
                  <Route
                    path="/cards"
                    render={() => <Gallery />}
                  />
                  <Redirect to="/cards" />
                </Switch>
                <FullScreenLogin />
              </ShopRouteCardCategoryProvider>
            </CardsRoutesProvider>
          </RoutesProvider>
        </PublicShopLoginProvider>
      </PublicCardShopTelemetryProvider>
    </>
  );
};
